import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'An author changed a setting on a content block of a collection share link page',
  name: 'block_updated',
  params: [
    {
      description: 'Which block setting the author changed',
      name: 'field_updated',
      required: true,
      type: 'enum',
      values: ['style', 'alignment', 'size', 'inset_width', 'image_layout', 'video_layout', 'video_playback'],
    },
  ],
};

export default META;
